// extracted by mini-css-extract-plugin
export var searchHeader = "_9q-0";
export var searchHeaderDark = "_9q-1";